const map = new Map<string, string>();

const storage = {
	getItem: (key: string) => {
		return map.get(key) || null;
	},

	setItem: (key: string, value: string) => {
		map.set(key, value);
	},
};

export default storage;
